import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const UPDATE_MYAPP_COMPONENT_NAME = gql`
  mutation createMyApp($componentId: Int!, $title: String!) {
    app {
      appVersionMutation {
        appVersionComponentMutation {
          updateComponentTitle(
            inputType: { componentId: $componentId, title: $title }
          )
        }
      }
    }
  }
`;

const updateMyAppComponentNameRequest = ({
  componentId,
  title,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={UPDATE_MYAPP_COMPONENT_NAME}>
    {(createMyApp, { loading, error, data }) => {
      const variables = {
        componentId,
        title,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data.app.submitApp);
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={createMyApp}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

updateMyAppComponentNameRequest.propTypes = {
  componentId: PropTypes.number.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

updateMyAppComponentNameRequest.defaultProps = {};

export default updateMyAppComponentNameRequest;
